@if ( ((potentialPromotions != null && potentialPromotions.length > 0) || (appliedOrderPromotions != null &&
appliedOrderPromotions.length > 0)) && !showSrp ) {
<div id="summary-promotion" class="summary-row promotion" [class.saved-cart]="savedCart === true">
  @for (promotion of potentialPromotions; track promotion) {
  <div class="summary-label">
    <mat-icon svgIcon="promotion"></mat-icon> <span [innerHTML]="promotion.description"> </span>
  </div>
  } @for (appliedPromotion of appliedOrderPromotions; track appliedPromotion) {
  <div class="summary-label">
    @if (appliedPromotion.promotion.description) {
    <mat-icon svgIcon="promotion"></mat-icon>
    <span [innerHTML]="appliedPromotion.promotion.description"> </span>
    }
  </div>
  }
</div>
}
